import { Check, ChevronRight } from "lucide-react";
import { publishBookingSelection } from "@/lib/bookingSelectionBridge";

export default function Packages({ t }) {
  const isHungarian = t.packages.kicker === "Csomagok és árak";
  const pricingNote = isHungarian
    ? "Az aktuális készülékárat és a választható extrákat a foglalás során látod, mindig az elérhető Telefonkához igazítva."
    : "Current device pricing and optional extras are shown during booking, matched to the Telefonka available for your date.";
  const cardPricingNote = isHungarian
    ? "Aktuális ár a foglalásnál"
    : "Current price shown at booking";

  return (
    <section id="packages" data-testid="section-packages" className="py-20 md:py-28 tk-section-anchor">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-center mb-14 max-w-3xl mx-auto">
          <span className="tk-eyebrow">
            <span className="tk-divider" />
            {t.packages.kicker}
            <span className="tk-divider" />
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl mt-5 text-[var(--ink)]">
            {t.packages.title}
          </h2>
          <p className="mt-4 text-[var(--ink-soft)] leading-relaxed">{pricingNote}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-7">
          {t.packages.tiers.map((tier, index) => (
            <article
              key={tier.name}
              data-testid={`package-${index + 1}`}
              className="tk-card p-8 flex flex-col"
            >
              <h3 className="font-serif text-3xl">{tier.name}</h3>
              <p className="text-sm mt-2 text-[var(--ink-soft)]">{tier.tagline}</p>
              <p className="mt-5 text-xs uppercase tracking-[0.12em] text-[var(--burgundy)]">
                {cardPricingNote}
              </p>
              <ul className="mt-6 space-y-3 mb-8 flex-1">
                {tier.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-3 text-sm">
                    <span className="mt-0.5 w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 bg-[var(--beige-100)] text-[var(--burgundy)]">
                      <Check size={13} strokeWidth={2.5} />
                    </span>
                    <span className="text-[var(--ink)]">{feature}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#booking"
                data-testid={`package-${index + 1}-cta`}
                onClick={() => publishBookingSelection({ selectedPackage: tier.name })}
                className="tk-btn-primary justify-center"
              >
                {t.packages.cta}
                <ChevronRight size={16} />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
